webpackJsonp([123922971680747],{

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SheShines = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(18);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactSlick = __webpack_require__(15);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(13);
	
	__webpack_require__(12);
	
	var _reactLinkedinInsight = __webpack_require__(16);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	;
	var icon2 = "https://winpeforum.com/assets/elements/DaivikRaval.png";
	var icon3 = "https://winpeforum.com/assets/elements/PratitiDasgupta.png";
	var icon4 = "https://winpeforum.com/assets/MsParitaAshar.png";
	
	var duration = 400;
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var SheShines = exports.SheShines = function (_React$Component) {
	  _inherits(SheShines, _React$Component);
	
	  function SheShines(args) {
	    _classCallCheck(this, SheShines);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	    _this.Speaker2 = [{
	      imgUrl: icon3,
	      desc: "<div>\nPratiti is an infrastructure and private markets finance professional with experience spanning project finance, capital raising, and investment analysis across renewables, digital infrastructure, and private credit in India, Southeast Asia, and Europe. A Winpe Ambassador , she has been a part of the community since 2021 and is highly passionate about spearheading the cause of diversity in alternative investments.\n\n\n\n\n\n\n \n          </div>",
	      name: "Pratiti Dasgupta ",
	      post: "<div> \n\n\n\n\n\n\n          </div>"
	    }];
	    _this.Speaker1 = [{
	      imgUrl: icon4,
	      desc: "<div>\nParita Ashar, CFA, is a Principal with OIJIF and has been with the Firm since 2017. She has more than 14 years of experience across Private Equity Investing and Equity Research. She manages OIJIF\u2019s Investments in Annapurna Finance, Capital Small Finance Bank, PNB MetLife and HomeLane and has full cycle experience from investments to exits. She was involved in delivering successful IPO of Capital Small Finance Bank and secondary exits in Annapurna Finance and PNB MetLife.\n<br/><br/>\n\nPrior to joining OIJIF, she has worked at the research desk of the institutional equities division of Ambit Capital. She was responsible for leading research on key listed companies in the sectors of cement, metals and mining and aviation and has also covered telecom and media sectors in the past. Her research and recommendations have been based on long term competitive advantages of companies, with strong focus on accounting and corporate governance practices of companies. Parita is a Chartered Accountant and a CFA Charter Holder.\n \n          </div>",
	      name: "Parita Ashar",
	      post: "<div>Principal <br/>\nOIJIF\n\n\n\n\n\n\n          </div>"
	    }];
	
	    return _this;
	  }
	
	  SheShines.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  SheShines.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  SheShines.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: slidesToShow,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "Winpe Ignite: Workshop on Financial Modelling for Investment Decisions",
	        image: "https://winpeforum.com/api/src/templates/emailers/assets/newsletter2022.png",
	        description: "On 1st August 2026, Winpe hosted an Ignite workshop on how financial models turn a founder's vision into testable, investable numbers. Featuring Parita Ashar (Principal, OJIF), moderated by Pratiti Dasgupta, the session explored how investors build, stress-test, and use financial models to underwrite real deals. Click here to view the recorded workshop.",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "toastshine_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "back_event" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/events/" },
	              _react2.default.createElement(
	                "i",
	                { className: "fa fa-arrow-left" },
	                " Back to Events"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "toastshine_section" },
	            _react2.default.createElement(
	              "div",
	              { className: "m_heading" },
	              "Winpe Ignite: Workshop on Financial Modelling for Investment Decisions "
	            ),
	            _react2.default.createElement("div", { className: "r_btm" }),
	            _react2.default.createElement(
	              "div",
	              { className: "date_heading" },
	              _react2.default.createElement(
	                "div",
	                { className: "date_heading" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "August 1, 2026"
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  " ",
	                  _react2.default.createElement(
	                    "i",
	                    null,
	                    "Online"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "top_text", style: { textAlign: 'justify' } },
	              "On 1st August 2026, Winpe hosted an Ignite workshop on how financial models turn a founder's vision into testable, investable numbers. Featuring  ",
	              _react2.default.createElement(
	                "a",
	                { style: { color: 'blue' }, href: "https://www.linkedin.com/in/parita-ashar-cfa-28a9b23b?utm_source=share_via&utm_content=profile&utm_medium=member_android" },
	                "Parita Ashar"
	              ),
	              " (Principal, OJIF), moderated by ",
	              _react2.default.createElement(
	                "a",
	                { style: { color: 'blue' }, href: "https://www.linkedin.com/in/pratiti-dasgupta-bb92671b1/" },
	                "Pratiti Dasgupta"
	              ),
	              ", the session explored how investors build, stress-test, and use financial models to underwrite real deals. Click ",
	              _react2.default.createElement(
	                "a",
	                { style: { color: 'blue' }, href: "https://youtu.be/g4UtdA1jF5Y" },
	                "here"
	              ),
	              " to view the recorded workshop.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "A live poll kicked off the workshop: given two founders pitching the same coffee-chain opportunity, the room overwhelmingly backed the one who spoke in numbers over the one who spoke in vision, ",
	              _react2.default.createElement(
	                "b",
	                null,
	                "even though neither pitch actually proved which business was better"
	              ),
	              ". Parita used this to frame the whole session: conviction needs a model behind it, not just a story.",
	              _react2.default.createElement(
	                "h4",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Key Segments Discussed: "
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Financial Models: A Tool for Better Decision-Making"
	                ),
	                _react2.default.createElement("br", null),
	                " Financial models translate business assumptions into measurable outcomes, enabling both founders and investors to evaluate opportunities with greater clarity."
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "For founders, financial models help plan growth, anticipate capital requirements, and prepare for future business scenarios."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "For investors, they provide a structured framework to evaluate expected returns, compare opportunities, and assess investment risks."
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Building Blocks of a Financial Model"
	                ),
	                _react2.default.createElement("br", null),
	                "Using a coffee chain case study, the session demonstrated how investors break down business performance into measurable drivers instead of relying on high-level projections."
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Revenue drivers such as customer footfall, pricing, and store expansion, alongside cost structures, operating leverage, and margin assumptions."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Cash flow planning and capital requirements as key indicators of business sustainability."
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Scenario Analysis & Investment Evaluation"
	                ),
	                _react2.default.createElement("br", null),
	                "Rather than relying on a single forecast, participants explored how investors stress-test assumptions and evaluate a range of possible outcomes."
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Understanding base, downside, and upside scenarios through sensitivity analysis to assess investment risk and expected returns."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Comparing different investment opportunities through risk-return trade-offs rather than headline metrics."
	                )
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h4",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Key Takeaways"
	                )
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Financial models are decision-making tools, not just spreadsheets."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Strong investment decisions begin with testing assumptions and understanding the range of possible outcomes, not accepting a single projection at face value."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Cash generation and risk-return trade-offs matter as much as profitability when evaluating a business."
	                )
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h4",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Tools & Platforms Mentioned"
	                )
	              ),
	              _react2.default.createElement(
	                "ul",
	                { style: { columnCount: 3, columnGap: '20px' } },
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Two-Variable Data Tables (Excel)"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Scenario & Sensitivity Analysis"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "EV/EBITDA Multiple Analysis"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Revenue Build-Up Modelling"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "Cash Conversion Cycle"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  "COCO vs. FOCO (ROIC) Analysis"
	                )
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  _react2.default.createElement(
	                    "i",
	                    null,
	                    "Financial models do not predict the future\u2014they help investors understand how changes in assumptions influence risk, expected returns, and ultimately, investment decisions."
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { "class": "row" },
	              _react2.default.createElement(
	                "div",
	                { "class": "col-md-2" },
	                "\xA0"
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "col-md-4" },
	                _react2.default.createElement(
	                  "h2",
	                  { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                  "Facilitator"
	                ),
	                "          ",
	                _react2.default.createElement("div", { "class": "r_btm" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "Our_Speakers container" },
	                  _react2.default.createElement(
	                    "center",
	                    null,
	                    _react2.default.createElement(
	                      "div",
	                      { className: "Speakers_img", style: { width: '60%' } },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        this.Speaker1.map(function (item, i) {
	                          if (i <= 12) {
	                            return _react2.default.createElement(
	                              "div",
	                              {
	                                className: "main_speaker_card col-md-12 col-sm-12 col-lg-12",
	                                key: i
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "Scardd" },
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "s_img",
	                                    onClick: function onClick() {
	                                      return _this3.togglePopUp(item);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    "center",
	                                    null,
	                                    "  ",
	                                    _react2.default.createElement("img", {
	                                      src: item.imgUrl,
	                                      alt: item.name,
	                                      className: "img-responsive",
	                                      style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                    })
	                                  )
	                                ),
	                                _react2.default.createElement("br", null),
	                                "    ",
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_name",
	                                  dangerouslySetInnerHTML: { __html: item.name }
	                                }),
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_post",
	                                  dangerouslySetInnerHTML: { __html: item.post }
	                                })
	                              )
	                            );
	                          } else return _react2.default.createElement(
	                            "div",
	                            {
	                              className: "main_speaker_card col-md-6 col-sm-12 col-lg-6",
	                              key: i
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "Scardd" },
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "s_img",
	                                  onClick: function onClick() {
	                                    return _this3.togglePopUp(item);
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  "center",
	                                  null,
	                                  "  ",
	                                  _react2.default.createElement("img", {
	                                    src: item.imgUrl,
	                                    alt: item.name,
	                                    className: "img-responsive",
	                                    style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement("br", null),
	                              "    ",
	                              _react2.default.createElement("div", {
	                                className: "Speakers_name",
	                                dangerouslySetInnerHTML: { __html: item.name }
	                              }),
	                              _react2.default.createElement("div", {
	                                className: "Speakers_post",
	                                dangerouslySetInnerHTML: { __html: item.post }
	                              })
	                            )
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "col-md-4" },
	                _react2.default.createElement(
	                  "h2",
	                  { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                  "Moderator"
	                ),
	                "          ",
	                _react2.default.createElement("div", { "class": "r_btm" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "Our_Speakers container" },
	                  _react2.default.createElement(
	                    "center",
	                    null,
	                    _react2.default.createElement(
	                      "div",
	                      { className: "Speakers_img", style: { width: '50%' } },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        this.Speaker2.map(function (item, i) {
	                          if (i <= 12) {
	                            return _react2.default.createElement(
	                              "div",
	                              {
	                                className: "main_speaker_card col-md-12 col-sm-12 col-lg-12",
	                                key: i
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "Scardd" },
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "s_img",
	                                    onClick: function onClick() {
	                                      return _this3.togglePopUp(item);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    "center",
	                                    null,
	                                    "  ",
	                                    _react2.default.createElement("img", {
	                                      src: item.imgUrl,
	                                      alt: item.name,
	                                      className: "img-responsive",
	                                      style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                    })
	                                  )
	                                ),
	                                _react2.default.createElement("br", null),
	                                "    ",
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_name",
	                                  dangerouslySetInnerHTML: { __html: item.name }
	                                }),
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_post",
	                                  dangerouslySetInnerHTML: { __html: item.post }
	                                })
	                              )
	                            );
	                          } else return _react2.default.createElement(
	                            "div",
	                            {
	                              className: "main_speaker_card col-md-6 col-sm-12 col-lg-6",
	                              key: i
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "Scardd" },
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "s_img",
	                                  onClick: function onClick() {
	                                    return _this3.togglePopUp(item);
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  "center",
	                                  null,
	                                  "  ",
	                                  _react2.default.createElement("img", {
	                                    src: item.imgUrl,
	                                    alt: item.name,
	                                    className: "img-responsive",
	                                    style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement("br", null),
	                              "    ",
	                              _react2.default.createElement("div", {
	                                className: "Speakers_name",
	                                dangerouslySetInnerHTML: { __html: item.name }
	                              }),
	                              _react2.default.createElement("div", {
	                                className: "Speakers_post",
	                                dangerouslySetInnerHTML: { __html: item.post }
	                              })
	                            )
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(TeamModal, {
	            show: isShow,
	            onHide: this.togglePopUp,
	            activeItem: this.state.activeItem
	          })
	        )
	      )
	    );
	  };
	
	  return SheShines;
	}(_react2.default.Component);
	
	SheShines.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = SheShines;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-ignite-workshop-on-financial-modelling-index-js-46d166c81046bb8bfb0b.js